import { lazy } from 'react';
import { DashboardLayout } from '../../../app/components';
import { routingPath } from '../../../app/routes';

const SimulationMain = lazy(() =>
  import('../pages/SimulationMain').then((m) => ({
    default: m.SimulationMain,
  })),
);

const SimulationRoutes = () => {
  return {
    element: <DashboardLayout />,
    children: [
      {
        path: routingPath.simulation.main,
        element: <SimulationMain />,
      },
    ],
  };
};

export default SimulationRoutes;
